import type { VoidFunctionComponent } from 'react';

/**
 * Code tab for the SnippetDrawer.
 * Displays code matches for a given snippet.
 */
const SnippetsDrawerCode: VoidFunctionComponent = () => {
  return (
    <div>
      Code view for your snippet. See what your snippet matched etc. Coming soon!
    </div>
  );
};

export default SnippetsDrawerCode;
